

import StoneIcon from './img/items/stone.svg';
import TwigIcon from './img/items/branch.svg';
import AppleIcon from './img/items/apple.svg';
import BeerIcon from './img/items/beer.svg';

function rand(n){
    const r = (Math.random() * n) - n/2;
    return r;
}

export default {
    bedroom: {
        key: "bedroom",
        scene: {
            backgroundColor: "#87cbff",
            model: "data/models/island-scene-decoration.gltf",
            collider_model: "data/models/island-scene.gltf",
            backgroundMusic: "background",
            ambianceMusic: "ambiance_jungle",
            light: {
                global: true
            }
        },
        elements: [
            ...(new Array(10).fill(undefined).map(()=>({ type: 'item', key: 'rock', icon: StoneIcon, position: [rand(75), 1, rand(75)], rotation: [0.0,0.0,Math.PI/2], scale: [0.005,0.005,0.005], data: { sceneState: "laptop:bought"}}))),
            ...(new Array(10).fill(undefined).map(()=>({ type: 'item', key: 'twig', icon: TwigIcon, position: [rand(75), 1, rand(75)], rotation: [0.0,0.0,Math.PI/2], scale: [0.01,0.01,0.01], data: { sceneState: "laptop:bought"}}))),
            ...(new Array(2).fill(undefined).map(()=>({ type: 'item', key: 'soda', icon: BeerIcon, position: [rand(75), 1, rand(75)], rotation: [0.0,0.0,Math.PI/2], scale: [0.02,0.02,0.02], data: { type: "drink", sceneState: "laptop:bought", drink: 3, drunk: 1}}))),
            ...(new Array(10).fill(undefined).map(()=>({ type: 'item', key: 'apple', icon: AppleIcon, position: [rand(75), 1, rand(75)], rotation: [0.0,0.0,0], scale: [0.015,0.015,0.015], data: { type: "food", sceneState: "laptop:bought", food: 1, drink: 1}}))),
            { type: 'zone', key: 'toilet', position: [-5.8147,1.00,16.576], rotation: [0,0,0], scale: [0.5,0.5,0.5], data: { hint: "Pee", invisible: true}},
            { type: 'zone', key: 'level', position: [-40.98,0.87,-7.64], rotation: [0,0,0], scale: [0.5,0.5,0.5], data: { scene: "cave", invisible: true}},
            { type: 'npc', key: 'woman', position: [34.19,0,-35.62], rotation: [0.0,0,0.0], scale: [1.1,1.1,1.1]},
            { type: 'zone', key: 'trigger', position: [0,-1, 0], rotate: [0,0,0], scale: [300,0.1,300], data: { death: true, invisible: true, triggerAuto: true}},
            { type: 'zone', key: 'level', position: [0,-30, 0], rotate: [0,0,0], scale: [300,0.1,300], data: { scene: "empty", invisible: true, triggerAuto: true}},
            { type: 'prop', key: 'campfire', position: [-5,0.3, 3.8], rotate: [0,0,0], scale: [1,1,1], data: { renderType: 'blueprint' }, sceneStateCondition: "!campfire:built"},
            { type: 'prop', key: 'campfire', position: [-5,0.3, 3.8], rotate: [0,0,0], scale: [1,1,1], data: {  }, sceneStateCondition: "campfire:built"},
            { type: 'fire', key: 'fire', position: [-5.05,0.7, 3.85], rotate: [0,0,0], scale: [1,1,1], data: {  }, sceneStateCondition: "fire:lit"},
            { type: 'zone', key: 'build', position: [-5,0.3, 3.8], rotate: [0,0,0], scale: [1.5,1,1.5], data: { hint: "Construire (3 branches + 4 pierres)", invisible: true, items: {twig: 3, rock: 4}, buildSceneState: "campfire:built"}, sceneStateCondition: "!campfire:built"},
            { type: 'zone', key: 'build', position: [-5,0.3, 3.8], rotate: [0,0,0], scale: [1.5,1,1.5], data: { hint: "Allumer (2 pierres)", invisible: true, items: {rock: 2}, buildSceneState: "fire:lit"}, sceneStateCondition: "campfire:built"},

            { type: 'prop', key: 'garden', position: [-9.64,0.3, 1.77], rotate: [0,0,0], scale: [1,1,1], data: { renderType: 'blueprint' }, sceneStateCondition: "!garden:built"},
            { type: 'prop', key: 'garden', position: [-9.64,0.3, 1.77], rotate: [0,0,0], scale: [1,1,1], data: { }, sceneStateCondition: "garden:built"},
            { type: 'zone', key: 'build', position: [-9.64,0.3, 1.77], rotate: [0,0,0], scale: [2,1,2], data: { hint: "Construire (4 branches)", invisible: true, items: {twig: 4}, buildSceneState: "garden:built"}, sceneStateCondition: "!garden:built"},
            { type: 'prop', key: 'tree', position: [-9.64,0.3, 1.77], rotate: [0,0,0], scale: [1,1,1], data: { renderType: 'blueprint' }, sceneStateCondition: "garden:built"},
            { type: 'prop', key: 'tree', position: [-9.64,0.3, 1.77], rotate: [0,0,0], scale: [1,1,1], data: { }, sceneStateCondition: "tree:built"},
            { type: 'zone', key: 'build', position: [-9.64,0.3, 1.77], rotate: [0,0,0], scale: [2,1,2], data: { hint: "Planter (1 pomme)", invisible: true, items: {apple: 1}, buildSceneState: "tree:built"}, sceneStateCondition: "garden:built"},
            { type: 'zone', key: 'spawn', position: [-9.64,2, 1.77], rotate: [0,0,0], scale: [1,1,1], data: { hint: "", invisible: true, item: 'apple', interval: 60}, sceneStateCondition: "tree:built"},
            
            
            /*{ type: 'item', key: 'enveloppe', position: [-1.5, 0.5, 1.8], rotation: [-80,0.0,0.0], scale: [0.015,0.015,0.015], data: {sceneState: "acceptance-letter:read", content: letterText}  },
            { type: 'item', key: 'briefcase', position: [2.5, 0.5, 0], rotation: [0.0,0.0,0.0], scale: [0.01,0.01,0.01], data: { sceneState: "briefcase:taken"}, sceneStateCondition: "laptop:bought"},
            { type: 'item', key: 'book', position: [4, 1, 4.5], rotation: [5.0,0.0,5.0], scale: [0.015,0.015,0.015], data: { content: bookPages}},
            { type: 'zone', key: 'level', position: [-1.8, 0.5, 1.8], rotation: [0.0,0.0,0.0], scale: [0.5,0.5,0.5], data: { levels: [{name:"bedroom"},{name:"office", sceneStateCondition: "quiz:success"}, {name:"shop"}] }, sceneStateCondition: "money:taken"},
            { type: 'zone', key: 'game', position: [-1.1, 0.2, 4], rotation: [0.0,0.0,0.0], scale: [0.3,0.2,0.3], data: { url: "https://miniroyale.io/", hint: "Play game", screenRatio: '16 / 9', invisible: true }},
            { type: 'zone', key: 'bed', position: [3, 0.5, 1.5], rotation: [0.0,0.0,0.0], scale: [0.5,0.2,0.5], data: { hint: "Sleep", invisible: true}},
            { type: 'prop', key: 'laptop', position: [0.65, 0.75, 0], rotation: [0.0,0.0,0.0], scale: [1.0,1.0,1.0], sceneStateCondition: 'briefcase:taken'},
            //{ type: 'zone', key: 'computer', position: [0.8, 0.5, 0.8], rotation: [0.0,0.0,0.0], scale: [0.5,0.5,0.5], sceneStateCondition: 'briefcase:taken', data: { quiz: "introduction"}},
            { type: 'item', key: 'money', position: [1.5, 1, 2], rotation: [0.0,0.0,20.0], scale: [0.02,0.02,0.02], data: { amount: 900}, sceneStateCondition: 'acceptance-letter:read'},
            { type: 'zone', key: 'computer', position: [1.2, 0.5, 0.9], rotation: [0.0,0.0,0.0], scale: [0.5,0.5,0.5], sceneStateCondition: 'briefcase:taken', data: { computer: true, defaultTab: "quiz", disabledTabs: ["missions"]}},
        */].map((e, i) => { e.uid = "obj_"+((Math.random()+"").substring(2)) ;return e;}),
        player: {
            position: [2, 5 , 2],
            rotation: 0,
            camera: {x:0.4, y: 0},
            from: {
                cave: {
                    position: [-40.86,1.037,-3.88],
                    rotation: Math.PI/2,
                    camera: {x:0.4, y: Math.PI}
                },
                empty: {
                    position: [11,1.037,43],
                    rotation: Math.PI/2,
                    camera: {x:0.4, y: Math.PI}
                }
            }
        },
        events: [{
            trigger: { type: 'scene:loaded'},
            condition: { type: "sceneState", data: {sceneState: "level:0:loaded"}, operator: "not"},
            actions: [
                { type: 'sound', delay: 3, data: { audio : "voice_hello", speed: 1.1 }, sceneState: "level:0:loaded"},
            ]
        }]
    },
    cave: {
        key: "cave",
        scene: {
            backgroundColor: "#000",
            model: "data/models/empty-scene.gltf",
            collider_model: "data/models/cave-scene.gltf",
            backgroundMusic: "background_empty",
            light: {
                global: false
            }
        },
        elements: [
            { type: 'zone', key: 'level', position: [9.10, 1.36, -21.02], rotation: [0.0,0.0,0.0], scale: [0.5,0.5,0.5], data: { scene: "bedroom", hint: "Sortir", invisible:true }},
            { type: 'zone', key: 'sound', position: [4.96, 0.75, -10.3], rotation: [0.0,0.0,0.0], scale: [1.5,0.5,1.5], data: { audio: "voice_cave_good",triggerAuto:true, invisible:false }},
            { type: 'zone', key: 'sound', position: [-0.9, 0.75, 2.2], rotation: [0.0,0.0,0.0], scale: [1.5,0.5,1.5], data: { audio: "voice_cave_bad",triggerAuto:true, invisible:false }},
            { type: 'zone', key: 'sound', position: [9.10, 1.36, -21.02], rotation: [0.0,0.0,0.0], scale: [1.5,0.5,1.5], data: { audio: "voice_cave_finish",triggerAuto:true, invisible:false }},
        ],
        player: {
            position: [-0.13, 0.5 , -1.31],
            rotation: Math.PI/2,
            camera: {x:0.4, y: Math.PI}
        },
        events: []
    },
    empty: {
        key: "empty",
        scene: {
            backgroundColor: "#000",
            model: "data/models/empty-scene.gltf",
            collider_model: "data/models/empty-scene.gltf",
            backgroundMusic: "background_empty",
            light: {
                global: false
            }
        },
        elements: [
        ],
        player: {
            position: [0, 0.5 , 0],
            rotation: 0,
            camera: {x:0.4, y: 0}
        },
        events: [{
            trigger: { type: 'scene:loaded'},
            actions: [
                { type: 'sound', data: { audio : "voice_drown" }},
                { type: 'sound', delay:5, data: { audio : "voice_second_chance" }},
                { type: 'level', delay: 8, data: { scene: "bedroom" }},
            ]
        }]
    }
    /*office: {
        key: "office",
        scene: {
            model: "data/models/office-scene.gltf",
            collider_model: "data/models/office-collider.fbx",
            backgroundMusic: "office"
        },
        elements: [ 
            { type: 'item', key: 'snack', position: [-6, 0.5, -6], rotation: [0.0,0.0,0.0], scale: [0.02,0.02,0.02], data: {sceneState: 'snack:taken'}, sceneStateCondition: 'arcade:interacted'},
            { type: 'npc', key: 'boss', position: [-1.5, 0, -3], rotation: [0.0,5.0,0.0], scale: [1,1,1]},
            { type: 'npc', key: 'developer', position: [3.9, -0.3, 7.5], rotation: [0.0,3.0,0.0], scale: [1,1,1], sceneStateCondition: 'snack:taken'},
            { type: 'zone', key: 'level', position: [-2.4, 0.5, -7], rotation: [0.0,0.0,0.0], scale: [0.5,0.5,0.5], data: { levels: [{name: 'office'},{name: 'school'}] }, sceneStateCondition: 'challenge:succeeded'},
            { type: 'zone', key: 'computer', position: [1.9, 0.5, 7.8], rotation: [0.0,0.0,0.0], scale: [0.5,0.5,0.5], data: { computer: true, defaultTab: "missions", disabledTabs: []}, sceneStateCondition: 'coworker:talked'},
            { type: 'zone', key: 'game', position: [0, 0.5, -1.3], rotation: [0.0,0.0,0.0], scale: [0.5,0.5,0.5], data: { url:  "https://funhtml5games.com?embed=spaceinvaders", sceneState: 'arcade:interacted', hint: "Play arcade", screenRatio: '4.22 / 3'}, sceneStateCondition: 'boss:talked'},
            { type: 'item', key: 'money', position: [-2.5, 1, -1], rotation: [0.0,0.0,20.0], scale: [0.02,0.02,0.02], data: { amount: 10}, sceneStateCondition: 'challenge:succeeded'},
            { type: 'zone', key: 'vending-machine', position: [-6, 0.5, -6], rotation: [0.0,0.0,0.0], scale: [0.5,0.5,0.5], data: { hint: "Buy", items: [
                {name: "Soda", key: "soda", price: 4, icon: CanIcon},
                {name: "Energy Drink", key: "soda", price: 6, icon: EnergyCanIcon},
                {name: "Hot Dog", key: "hotdog", price: 8, icon: HotDogIcon}
            ]}, sceneStateCondition: 'challenge:succeeded'},
            { type: 'zone', key: 'toilet', position: [-7,0.5,3.3], rotation: [0,0,0], scale: [0.5,0.5,0.5], data: { hint: "Pee", invisible: true}},
        ],
        player: {
            position: [-3, 5 , -3],
            rotation: 0 
        }
    },
    school: {
        key: "school",
        scene: {
            model: "data/models/school-scene.gltf",
            collider_model: "data/models/school-collider.fbx",
            backgroundMusic: "office"
        },
        elements: [
            { type: 'npc', key: 'teacher', position: [-19,0.6,-4], rotation: [0.0,2,0.0], scale: [1,1,1]},
            { type: 'zone', key: 'toilet', position: [-19,1,16], rotation: [0,0,0], scale: [0.5,0.5,0.5], data: { hint: "Pee", invisible: true}},
            { type: 'zone', key: 'toilet', position: [-17,1,16], rotation: [0,0,0], scale: [0.5,0.5,0.5], data: { hint: "Pee", invisible: true}},
            { type: 'zone', key: 'toilet', position: [-16,1,16], rotation: [0,0,0], scale: [0.5,0.5,0.5], data: { hint: "Pee", invisible: true}},
            { type: 'zone', key: 'toilet', position: [-17,1,19], rotation: [0,0,0], scale: [0.5,0.5,0.5], data: { hint: "Pee", invisible: true}},
            { type: 'zone', key: 'toilet', position: [-16,1,19], rotation: [0,0,0], scale: [0.5,0.5,0.5], data: { hint: "Pee", invisible: true}},
            { type: 'projector', key: 'projector', position: [-19.7,2.3,-7.4], rotation: [0,Math.PI/2,0], scale: [2,2,2], data:{video: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4'}, sceneStateCondition: 'course:started'}
        ],
        player: {
            position: [-0, 5 , 25],
            rotation: Math.PI
        }
    },*/
}
